export const initProductFavorites = () => {
    const container = document.querySelector('#hits, .product-section, .product-view-section');

    if (container) {
        container.addEventListener('click', function(event) {

            let target = event.target;
            while (target && target !== container) {
                if (target.classList && target.classList.contains('js-mark-favorite')) {
                    event.preventDefault();

                    const ProductID = target.dataset.id;
                    if (!ProductID) {
                        return;
                    }

                    fetch(`/product-favorites/favorite/manage/?ProductID=${ProductID}`, {
                        method: 'GET',
                        cache: 'no-store'
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log(data)
                            if (data.favorite) {
                                target.classList.add('favorite');
                            } else {
                                target.classList.remove('favorite');
                            }
                        })
                        .catch(error => {
                            console.error('Error:', error);
                        });
                    break;
                }
                target = target.parentElement;
            }
        });
    }
};
